import {
    JOURNEY_UPDATED,
    JOURNEY_RESET,
    JOURNEY_PROGRESS_RESET,
    SESSION_INITIALISED,
    JWT_SET,
    JWT_CLEARED,
    LEAD_ID_SET,
    DOCUMENT_STATUSES_SET,
} from '../types/journey';

export const journeyUpdated = (journey, meta = {}) => ({
    type: JOURNEY_UPDATED,
    payload: journey,
    // Per-dispatch context about the envelope this snapshot came from. Only
    // `fnoAuthoritative` is read today (see the journey reducer): it marks the
    // one endpoint that actually computes postEsignFno, so its null may clear
    // the stored value while every other envelope's null is ignored.
    meta,
});

export const journeyReset = () => ({
    type: JOURNEY_RESET,
});

export const journeyProgressReset = () => ({
    type: JOURNEY_PROGRESS_RESET,
});

export const sessionInitialised = (sessionId) => ({
    type: SESSION_INITIALISED,
    payload: sessionId,
});

export const jwtSet = (token) => ({
    type: JWT_SET,
    payload: token,
});

export const jwtCleared = () => ({
    type: JWT_CLEARED,
});

export const leadIdSet = (leadId) => ({
    type: LEAD_ID_SET,
    payload: leadId,
});

export const setDocumentStatuses = (statuses) => ({
    type: DOCUMENT_STATUSES_SET,
    payload: statuses ?? [],
});
